import { useParams } from "react-router-dom";
import { PortalShell } from "./PortalShell";
import { QuizResultView } from "./PortalQuiz";

export default function PortalQuizResult() {
  const { attemptId } = useParams();
  return <PortalShell><QuizResultView attemptId={attemptId} /></PortalShell>;
}
